var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPersonBigCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z",
    fill: "#0033AD",
    fillOpacity: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 23C33.65 23 35 24.35 35 26C35 27.65 33.65 29 32 29C30.35 29 29 27.65 29 26C29 24.35 30.35 23 32 23ZM32 36.5C36.05 36.5 40.7 38.435 41 39.5V41H23V39.515C23.3 38.435 27.95 36.5 32 36.5ZM32 20C28.685 20 26 22.685 26 26C26 29.315 28.685 32 32 32C35.315 32 38 29.315 38 26C38 22.685 35.315 20 32 20ZM32 33.5C27.995 33.5 20 35.51 20 39.5V44H44V39.5C44 35.51 36.005 33.5 32 33.5Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPersonBigCircle);
export default __webpack_public_path__ + "static/media/ic_person_big_circle.4a454662883169bac4efe2cddbcb8747.svg";
export { ForwardRef as ReactComponent };